import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  FormFeedback,
} from "reactstrap";
import UserHeader from "components/Headers/UserHeader.js";
import { ToastContainer, toast } from "react-toastify"; // Import Toastify
import "react-toastify/dist/ReactToastify.css"; // Import styles for Toastify
import Stageslist from "components/Stageslist/Stageslist.js";

const Createstage = () => {
  const [formData, setFormData] = useState({
    stage: "",
    tokensToSell: "",
    priceUSD: "",
    usdCap: "",
    min_per_transaction: "",
    max_per_transaction: "",
    soft_cap: "",
    hard_cap: "",
    start_date: "",
    end_date: "",
    block: "",
    start_percentage: 0,
    durationDays: "", // Added durationDays field
  });

  const [errors, setErrors] = useState({});

  // Handle changes to the form fields
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Automatically capitalize the first letter of the block field
    if (name === "block") {
      setFormData({
        ...formData,
        [name]: value.charAt(0).toUpperCase() + value.slice(1),
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // Validate the form data before submitting
  const validateForm = () => {
    let formErrors = {};
    let valid = true;

    if (!formData.stage || isNaN(formData.stage) || parseInt(formData.stage, 10) <= 0) {
      formErrors.stage = "Stage number is required and must be a positive number!";
      valid = false;
    }

    if (!formData.tokensToSell || isNaN(formData.tokensToSell) || parseInt(formData.tokensToSell, 10) <= 0) {
      formErrors.tokensToSell = "Tokens to Sell must be a positive number!";
      valid = false;
    }

    if (!formData.priceUSD || isNaN(formData.priceUSD) || parseFloat(formData.priceUSD) <= 0) {
      formErrors.priceUSD = "Price USD must be a positive number!";
      valid = false;
    }

    if (!formData.usdCap || isNaN(formData.usdCap) || parseFloat(formData.usdCap) <= 0) {
      formErrors.usdCap = "USD Cap must be a positive number!";
      valid = false;
    }

    if (!formData.min_per_transaction || isNaN(formData.min_per_transaction) || parseInt(formData.min_per_transaction, 10) <= 0) {
      formErrors.min_per_transaction = "Min per Transaction must be a positive number!";
      valid = false;
    }

    if (!formData.max_per_transaction || isNaN(formData.max_per_transaction) || parseInt(formData.max_per_transaction, 10) <= 0) {
      formErrors.max_per_transaction = "Max per Transaction must be a positive number!";
      valid = false;
    }

    if (formData.soft_cap && (isNaN(formData.soft_cap) || parseFloat(formData.soft_cap) <= 0)) {
      formErrors.soft_cap = "Soft Cap must be a positive number!";
      valid = false;
    }

    if (formData.hard_cap && (isNaN(formData.hard_cap) || parseFloat(formData.hard_cap) <= 0)) {
      formErrors.hard_cap = "Hard Cap must be a positive number!";
      valid = false;
    }

    if (!formData.start_date) {
      formErrors.start_date = "Start Date is required!";
      valid = false;
    }

    if (!formData.end_date) {
      formErrors.end_date = "End Date is required!";
      valid = false;
    }

    // Validation for durationDays
    if (!formData.durationDays || isNaN(formData.durationDays) || parseInt(formData.durationDays, 10) <= 0) {
      formErrors.durationDays = "Duration Days is required and must be a positive number!";
      valid = false;
    }

    setErrors(formErrors);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    // Prepare the data to send to the backend
    // Added helper to prevent NaN values for optional fields
  const dataToSend = {
      stage: parseInt(formData.stage, 10),
      tokensToSell: parseInt(formData.tokensToSell, 10),
      priceUSD: parseFloat(formData.priceUSD),
      usdCap: parseFloat(formData.usdCap),
      tokensSold: 0,
      usdRaised: 0,
      isCurrent: true,
      min_per_transaction: parseInt(formData.min_per_transaction, 10),
      max_per_transaction: parseInt(formData.max_per_transaction, 10),
      soft_cap: formData.soft_cap ? parseFloat(formData.soft_cap) : 0,
      hard_cap: formData.hard_cap ? parseFloat(formData.hard_cap) : 0,
      
      // FIX: Change start_date to startAt and end_date to endAt to match your API
      startAt: formData.start_date, 
      endAt: formData.end_date,
      
      block: formData.block,
      start_percentage: formData.start_percentage ? parseFloat(formData.start_percentage) : 0,
      durationDays: parseInt(formData.durationDays, 10),
    };

    try {
      const token = localStorage.getItem("token");

      const response = await fetch(`${process.env.REACT_APP_API_URL}/stages`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      // Reset form data on success
      setFormData({
        stage: "",
        tokensToSell: "",
        priceUSD: "",
        usdCap: "",
        min_per_transaction: "",
        max_per_transaction: "",
        soft_cap: "",
        hard_cap: "",
        start_date: "",
        end_date: "",
        block: "",
        start_percentage: 0,
        durationDays: "", // Reset durationDays
      });

      toast.success("Stage created successfully!", {
        position: "top-center",
        autoClose: 3000,
      });
      console.log(data);
      
    } catch (err) {
      console.error("Error submitting form:", err);
      toast.error(err.message, {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  return (
    <>
      <UserHeader />
      <Container
        className="mt--7"
        style={{ background: "#251d0c", paddingBottom: "100px" }}
        fluid
      >
        <Row>
          <Col className="order-xl-1" xl="12">
            <Card className="bg-dark shadow">
              <CardBody style={{ background: "black" }}>
                <Form onSubmit={handleSubmit}>
                  <h6
                    className="heading-small text-light mb-4"
                    style={{ fontSize: "1.5rem" }}
                  >
                    Details
                  </h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            style={{ fontSize: "1.4rem" }}
                            className="form-control-label text-light"
                            htmlFor="input-stage"
                          >
                            Stage Number
                          </label>
                          <Input
                            name="stage"
                            value={formData.stage}
                             min={0}
                            onChange={handleChange}
                            placeholder="4"
                            type="number"
                            style={{
                              backgroundColor: "#333",
                              color: "#FFB000",
                              fontSize: "1.2rem",
                            }}
                            invalid={!!errors.stage}
                          />
                          {errors.stage && (
                            <FormFeedback>{errors.stage}</FormFeedback>
                          )}
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            style={{ fontSize: "1.4rem" }}
                            className="form-control-label text-light"
                            htmlFor="input-durationDays"
                          >
                            Duration (Days)
                          </label>
                          <Input
                            name="durationDays"
                            value={formData.durationDays}
                            onChange={handleChange}
                            placeholder="30"
                            type="number"
                            style={{
                              backgroundColor: "#333",
                              color: "#FFB000",
                              fontSize: "1.2rem",
                            }}
                            invalid={!!errors.durationDays}
                          />
                          {errors.durationDays && (
                            <FormFeedback>{errors.durationDays}</FormFeedback>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            style={{ fontSize: "1.4rem" }}
                            className="form-control-label text-light"
                            htmlFor="input-tokensToSell"
                          >
                            Tokens to Sell
                          </label>
                          <Input
                            name="tokensToSell"
                            value={formData.tokensToSell}
                            onChange={handleChange}
                            placeholder="262500000"
                            type="number"
                            style={{
                              backgroundColor: "#333",
                              color: "#FFB000",
                              fontSize: "1.2rem",
                            }}
                            invalid={!!errors.tokensToSell}
                          />
                          <h6 className="text-muted" style={{ fontSize: "1rem" }}>
                            Define how many tokens are available for sale on this stage
                          </h6>
                          {errors.tokensToSell && (
                            <FormFeedback>{errors.tokensToSell}</FormFeedback>
                          )}
                        </FormGroup>
                      </Col>

                      <Col lg="6">
                        <FormGroup>
                          <label
                            style={{ fontSize: "1.4rem" }}
                            className="form-control-label text-light"
                            htmlFor="input-priceUSD"
                          >
                            Price USD
                          </label>
                          <Input
                            name="priceUSD"
                            value={formData.priceUSD}
                            onChange={handleChange}
                            placeholder="0.0017"
                            type="number"
                                                        min={0}
                            step="0.0001"
                            style={{
                              backgroundColor: "#333",
                              color: "#FFB000",
                              fontSize: "1.2rem",
                            }}
                            invalid={!!errors.priceUSD}
                          />
                          <h6 className="text-muted" style={{ fontSize: "1rem" }}>
                            Define your token price in USD (e.g., 0.0017)
                          </h6>
                          {errors.priceUSD && (
                            <FormFeedback>{errors.priceUSD}</FormFeedback>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                    <hr className="my-4" style={{ borderColor: "white" }} />
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            style={{ fontSize: "1.4rem" }}
                            className="form-control-label text-light"
                            htmlFor="input-block"
                          >
                            Block
                          </label>
                          <Input
                            name="block"
                            value={formData.block}
                            onChange={handleChange}
                            placeholder="Block 1"
                            type="text"
                            style={{
                              backgroundColor: "#333",
                              color: "#FFB000",
                              fontSize: "1.2rem",
                            }}
                            invalid={!!errors.block}
                          />
                          {errors.block && (
                            <FormFeedback>{errors.block}</FormFeedback>
                          )}
                        </FormGroup>
                      </Col>

                      <Col lg="6">
                        <FormGroup>
                          <label
                            style={{ fontSize: "1.4rem" }}
                            className="form-control-label text-light"
                            htmlFor="input-start_percentage"
                          >
                            Start Percentage
                          </label>
                          <Input
                            name="start_percentage"
                            value={formData.start_percentage}
                            onChange={handleChange}
                            placeholder="50"
                            type="number"
                            step="0.01"
                            style={{
                              backgroundColor: "#333",
                              color: "#FFB000",
                              fontSize: "1.2rem",
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <hr className="my-4" style={{ borderColor: "white" }} />

                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            style={{ fontSize: "1.4rem" }}
                            className="form-control-label text-light"
                            htmlFor="input-usdCap"
                          >
                            USD Cap
                          </label>
                          <Input
                            name="usdCap"
                            value={formData.usdCap}
                            onChange={handleChange}
                            placeholder="446250"
                            type="number"
                            step="0.01"
                            style={{
                              backgroundColor: "#333",
                              color: "#FFB000",
                              fontSize: "1.2rem",
                            }}
                            invalid={!!errors.usdCap}
                          />
                          <h6 className="text-muted" style={{ fontSize: "1rem" }}>
                            Define the maximum USD cap for this stage
                          </h6>
                          {errors.usdCap && (
                            <FormFeedback>{errors.usdCap}</FormFeedback>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                    <hr className="my-4" style={{ borderColor: "white" }} />

                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            style={{ fontSize: "1.4rem" }}
                            className="form-control-label text-light"
                            htmlFor="input-min_per_transaction"
                          >
                            Min per Transaction
                          </label>
                          <Input
                            name="min_per_transaction"
                            value={formData.min_per_transaction}
                            onChange={handleChange}
                            placeholder="1"
                            type="number"
                            style={{
                              backgroundColor: "#333",
                              color: "#FFB000",
                              fontSize: "1.2rem",
                            }}
                            invalid={!!errors.min_per_transaction}
                          />
                          {errors.min_per_transaction && (
                            <FormFeedback>
                              {errors.min_per_transaction}
                            </FormFeedback>
                          )}
                        </FormGroup>
                      </Col>

                      <Col lg="6">
                        <FormGroup>
                          <label
                            style={{ fontSize: "1.4rem" }}
                            className="form-control-label text-light"
                            htmlFor="input-max_per_transaction"
                          >
                            Max per Transaction
                          </label>
                          <Input
                            name="max_per_transaction"
                            value={formData.max_per_transaction}
                            onChange={handleChange}
                            placeholder="10"
                            type="number"
                            style={{
                              backgroundColor: "#333",
                              color: "#FFB000",
                              fontSize: "1.2rem",
                            }}
                            invalid={!!errors.max_per_transaction}
                          />
                          {errors.max_per_transaction && (
                            <FormFeedback>
                              {errors.max_per_transaction}
                            </FormFeedback>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                    <hr className="my-4" style={{ borderColor: "white" }} />

                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            style={{ fontSize: "1.4rem" }}
                            className="form-control-label text-light"
                            htmlFor="input-soft_cap"
                          >
                            Soft Cap
                          </label>
                          <Input
                            name="soft_cap"
                            value={formData.soft_cap}
                            onChange={handleChange}
                            placeholder="5000"
                            type="number"
                            step="0.01"
                            style={{
                              backgroundColor: "#333",
                              color: "#FFB000",
                              fontSize: "1.2rem",
                            }}
                            invalid={!!errors.soft_cap}
                          />
                          {errors.soft_cap && (
                            <FormFeedback>{errors.soft_cap}</FormFeedback>
                          )}
                        </FormGroup>
                      </Col>

                      <Col lg="6">
                        <FormGroup>
                          <label
                            style={{ fontSize: "1.4rem" }}
                            className="form-control-label text-light"
                            htmlFor="input-hard_cap"
                          >
                            Hard Cap
                          </label>
                          <Input
                            name="hard_cap"
                            value={formData.hard_cap}
                            onChange={handleChange}
                            placeholder="10000"
                            type="number"
                            step="0.01"
                            style={{
                              backgroundColor: "#333",
                              color: "#FFB000",
                              fontSize: "1.2rem",
                            }}
                            invalid={!!errors.hard_cap}
                          />
                          {errors.hard_cap && (
                            <FormFeedback>{errors.hard_cap}</FormFeedback>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            style={{ fontSize: "1.4rem" }}
                            className="form-control-label text-light"
                            htmlFor="input-start_date"
                          >
                            Start Date
                          </label>
                          <Input
                            name="start_date"
                            value={formData.start_date}
                            onChange={handleChange}
                            type="date"
                            style={{
                              backgroundColor: "#333",
                              color: "#FFB000",
                              fontSize: "1.2rem",
                            }}
                            invalid={!!errors.start_date}
                          />
                          {errors.start_date && (
                            <FormFeedback>{errors.start_date}</FormFeedback>
                          )}
                        </FormGroup>
                      </Col>

                      <Col lg="6">
                        <FormGroup>
                          <label
                            style={{ fontSize: "1.4rem" }}
                            className="form-control-label text-light"
                            htmlFor="input-end_date"
                          >
                            End Date
                          </label>
                          <Input
                            name="end_date"
                            value={formData.end_date}
                            onChange={handleChange}
                            type="date"
                            style={{
                              backgroundColor: "#333",
                              color: "#FFB000",
                              fontSize: "1.2rem",
                            }}
                            invalid={!!errors.end_date}
                          />
                          {errors.end_date && (
                            <FormFeedback>{errors.end_date}</FormFeedback>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row className="d-flex justify-content-end">
                      <Col lg="3">
                        <Button
                          className="btn btn-primary mt-4"
                          size="lg"
                          style={{
                            backgroundColor: "#FFB000",
                            fontSize: "1.4rem",
                            fontWeight: "bolder",
                            border: "none",
                          }}
                          type="submit"
                        >
                          Create Stage
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Stageslist />
      <ToastContainer />
    </>
  );
};

export default Createstage;